<template>
  <div>
    <div> 
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading" 
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Manifestation Details</b-navbar-brand>
        </b-navbar>

        <banner-component :allModuleIdBanner="ffExportDetail.allModuleId ? ffExportDetail.allModuleId : ''
          " :jobSeriesBanner="ffExportDetail.mainSalesSeries ? ffExportDetail.mainSalesSeries : ''
            " :bannerClientName="ffExportDetail.clientName ? ffExportDetail.clientName : ''" iconId="fa fa-ship" />
        <!-- :bannerClientName="ImportDetail.clientName ? ImportDetail.clientName : ''" -->
        <b-card class="formCard">
          <b-card-text>
            <div>
              <b-row>
                <b-col lg="4"></b-col>
                 <b-col lg="12"> 
                  <ContainerTable
                    v-if="ffExportDetail.allModuleId"
                    :PMC_JOBID="ffExportDetail.allModuleId ? Number(ffExportDetail.allModuleId) : 0"
                    :containers="[]"
                    :showContainerStatus="''"
                    @status-change="activateUser"
                  />
                </b-col>
                <b-col lg="12">
                  <span class="error pull-right" v-if="ManifestationCreated"><b>{{ " " + ManifestationCreated
                      }}</b><br /></span> </b-col><b-col lg="12">
                  <span class="error pull-right" v-if="ManifestationUpdated"><b>{{ ManifestationUpdated
                      }}</b><br /></span> </b-col><b-col lg="12">
                  <!-- <span
                    v-if="
                      last_updated != '' &&
                      last_updated != null &&
                      last_updated != undefined
                    "
                    class="pull-right"
                  >
                    <b class="error">{{ last_updated }}</b>
                  </span> -->
                </b-col>
                <b-col cols="4" class="mt-2">
                  <label for="blType">Type <span class="error">*</span></label>

                  <model-list-select :list="agentTypeList" option-value="TypeVal" option-text="TypeTxt"
                    v-model="AddManifestationDetail.type_of_agent" placeholder="Select Type"
                    @input="getAgentConsigneeList(AddManifestationDetail.type_of_agent)"></model-list-select>
                  <span class="error" v-if="!AddManifestationDetail.type_of_agent">{{
                    errorManifest.type_of_agent
                  }}</span>
                </b-col>
                <b-col cols="4" class="mt-2">
                  <label for="blType">
                    {{ AddManifestationDetail.type_of_agent }}
                    <span class="error">*</span>
                  </label>
                  <model-list-select :list="getAllAgentColoaderList.length > 0
                    ? getAllAgentColoaderList
                    : AddManifestationDetail.type_of_agent == 'Agent'
                      ? $store.getters['common/getAllAgentColoaderList']
                      : $store.getters['common/getAllConsigneeList']
                    " option-value="agentName" option-text="agentName" v-model="AddManifestationDetail.AgentColoader"
                    :placeholder="AddManifestationDetail.type_of_agent == 'Consignee'
                      ? 'Select Consignee'
                      : 'Select Agent/Coloader'
                      " @input="getConsigneeAgentDetails"></model-list-select>
                  <span class="error" v-if="errorManifest.AgentColoader">{{
                    errorManifest.AgentColoader +
                    " " +
                    AddManifestationDetail.type_of_agent
                  }}</span>
                </b-col>
                <!-- <b-col class="col-md-3">
                  <label for="blType">To</label>
                  <model-list-select
                    :list="$store.getters['common/getAllAgentColoaderList']"
                    option-value="agentName"
                    option-text="agentName"
                    v-model="AddManifestationDetail.agent_coloder_txt"
                    placeholder="Select To"
                  ></model-list-select>
                </b-col> -->
              </b-row>
              <b-card class="mt-2"
                v-if="AddManifestationDetail.agent_coloder_txt || AddManifestationDetail.consignee_name">
                <table class="table table-sm table-bordered">
                  <tbody style="background: white">
                    <tr>
                      <th scope="col">SN.</th>
                      <th scope="col" style="width: 10%">Type</th>
                      <th scope="col" style="width: 35%">Particulars</th>
                      <th scope="col" style="width: 5%">Container Count</th>
                      <th scope="col" style="width: 15%">Amount (Accept Only Numbers)</th>
                      <th scope="col" style="width: 7%">Currency</th>
                      <th scope="col" style="width: 7%">Final AMT</th>
                      <th scope="col">Remarks</th>
                      <th scope="col">
                        Action
                        <b-button id="show-btn" size="sm" variant="primary" @click="addInvArry">
                          Add
                          <i class="fa fa-plus" aria-hidden="true"></i>
                        </b-button>
                      </th>
                    </tr>
                    <tr v-for="(itm, idx) in lineADDManifestationModalArray" :key="idx">
                      <th scope="row">{{ idx + 1 }}</th>
                      <td>
                        <model-list-select :isDisabled="itm.manifestationId != '' ? true : false" :list="TypeList"
                          v-model="itm.addManifestation_type" option-value="typeVal" option-text="typeText"
                          placeholder="Select Type"></model-list-select>
                        <span class="error" v-if="itm.addManifestation_type_err">{{
                          itm.addManifestation_type_err
                        }}</span>
                      </td>
                      <td>
                        <!-- <model-list-select
                          :isDisabled="itm.manifestationId != '' ? true : false"
                          :list="$store.getters['common/getAllLedgerList']"
                          v-model="itm.addManifestation_ledgerId"
                          option-value="ledger"
                          option-text="ledger"
                          placeholder="Select Particular"
                        ></model-list-select> -->
                        <model-list-select :isDisabled="itm.manifestationId != '' ? true : false" :list="ParticularList"
                          v-model="itm.addManifestation_ledgerId" option-value="partVal" option-text="partText"
                          placeholder="Select Particular"></model-list-select>
                        <span class="error" v-if="itm.addManifestation_ledgerId_err">{{
                          itm.addManifestation_ledgerId_err
                        }}</span>
                      </td>
                      <!-- <td>{{ itm.container_count||getSelectedContList.length }}</td> -->
                        <td ><b-form-input
                          :formatter="capitalizeAll"
                          id="container_count"
                          name="container_count"
                          v-model="itm.container_count"
                          @input="updateAmount(itm)"
                          @change="updateAmount(itm)"
                          v-on:keyup="TotalAMT"
                          type="number"
                        /></td>
                      <td>
                        <b-form-input :disabled="itm.manifestationId != '' || itm.addManifestation_type == ''
                          ? true
                          : false
                          " :formatter="capitalizeAll" id="amount" name="amount" v-model="itm.addManifestation_amount"
                          @input="CheckValueNumbers($event)" @change="CheckValueNumbers($event)" v-on:keyup="TotalAMT"
                          type="number"></b-form-input>
                        <span class="error" v-if="itm.addManifestation_amount_err">{{
                          itm.addManifestation_amount_err
                        }}</span>
                      </td>
                      <td>
                        <model-list-select :isDisabled="itm.manifestationId != '' ? true : false"
                          :list="$store.getters['common/getAllCurrencyList']" v-model="itm.addManifestation_currency"
                          option-value="currency_id" option-text="currencyCode"
                          placeholder="Select Currency"></model-list-select>
                        <span class="error" v-if="itm.addManifestation_currency_err">{{
                          itm.addManifestation_currency_err
                        }}</span>
                      </td>
                      <!-- <td>{{ getSelectedContList.length*itm.addManifestation_amount }}</td> -->
                       <td v-if="itm.manifestationId != ''">{{ itm.final_amt || itm.container_count*itm.addManifestation_amount }}</td>
                       <td v-if="itm.manifestationId==''">{{ itm.final_amt || getSelectedContList.length*itm.addManifestation_amount }}</td>
                      <td>
                        <b-form-textarea :disabled="itm.manifestationId != '' ? true : false" :formatter="capitalizeAll"
                          id="remark" name="remark" v-model="itm.addManifestation_remark"></b-form-textarea>
                        <span class="error" v-if="itm.addManifestation_remark_err">{{
                          itm.addManifestation_remark_err
                        }}</span>
                      </td>
                      
                      <td>
                        <b-button :disabled="itm.manifestationId != '' ? true : false" class="ml-auto" id="show-btn"
                          size="sm" variant="danger" @click="removeInvArry(idx)">
                          Remove
                          <i class="fa fa-minus" aria-hidden="true"></i>
                        </b-button>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3">
                        <b style="color: blue; font-weight: bold; font-size: 18px">Debit Total</b>
                      </td>
                      <td colspan="4">
                        <b style="color: blue; font-weight: bold; font-size: 18px">{{
                          TotDebit
                        }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3">
                        <b style="color: blue; font-weight: bold; font-size: 18px">Credit Total</b>
                      </td>
                      <td colspan="4">
                        <b style="color: blue; font-weight: bold; font-size: 18px">{{
                          TotCredit
                        }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3">
                        <b style="color: blue; font-weight: bold; font-size: 18px">Net Total</b>
                      </td>
                      <td colspan="4">
                        <b style="color: blue; font-weight: bold; font-size: 18px">{{
                          TotAMT
                        }}</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-card>
              <b-row>
                <b-col lg="5"></b-col>
                <b-col lg="2">
                  <b-button v-if="lineADDManifestationModalArray.length > 0" class="mt-3" size="sm" variant="primary"
                    id="addButtonLoaderSB" @click="addAddManifestationDetail">Save & Submit</b-button>

                  <md-spinner md-indeterminate id="loaderSB" style="display: none"></md-spinner>
                </b-col>
                <b-col lg="5"></b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>

        <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok"
          ref="popMailAfter"></md-dialog-confirm>

        <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
      </b-card-text>
    </b-card>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import Multiselect from "vue-multiselect";
import CommonService from "../../services/CommonService.js";

import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";
import ContainerTable from "../common/ContainerTable.vue";

export default {
  // props: ["allModuleId", "JOBSERIES"],
  beforeMount() {
    this.$store.dispatch(
      "common/setAllConsigneeList",
      JSON.stringify({
        itemCode: "ConsigneeList",
      })
    );

    // alert(this.$sessionsStorage.get("sendManifest_shipmentType"));
    if (
      this.$sessionsStorage.get("sendManifest_ffFclallModuleId") != undefined &&
      this.$sessionsStorage.get("sendManifest_ffFclallModuleId") != "" &&
      this.$sessionsStorage.get("JOBSERIES") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/freightForwarding/sendManifestation");
      if (
        this.$sessionsStorage.get("sendManifest_ffFclallModuleId") 
        // && this.$sessionsStorage.get("sendManifest_ffExportFclId")
      ) {
        // alert("PS")
        this.getData();
        this.$store.dispatch(
          "common/setAllCurrencyList",
          JSON.stringify({ Currency: "Currency_DropDown" })
        );
        this.$store.dispatch(
          "common/setAllLedgerList",
          JSON.stringify({
            itemCode: "LedgerList",
            JobType: '',
            ShipmentType: '',
            ModuleType: '',
            isLedgerActive: '1',
          })
        );
        this.$store.dispatch("common/setAllAgentColoaderList");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
  },

  data() {
    return {
      getSelectedContList:[],
      getAllAgentColoaderList: [],
      agentTypeList: [
        {
          TypeVal: "Consignee",
          TypeTxt: "Consignee",
        },
        {
          TypeVal: "Agent",
          TypeTxt: "Agent",
        },
      ],
      TotAMT: "0",
      TotDebit: "0",
      TotCredit: "0",
      branch_code: "",
      assign_no_series: this.$sessionsStorage.get("JOBSERIES"),
      allModuleId: this.$sessionsStorage.get("sendManifest_ffFclallModuleId"),
      selectDateFormat,
      accounts: false,
      ffExportDetail: {
        POD: "",
        allModuleId: "",
        clientName: "",
        ffExportFclSeries: "",
        portType: "",
        stuffingType: "",
        containerInfo: "",
        mergeffExportId: "",
        mergeSeries: "",
        shippingLine: "",
        FinalPlace: "",
        POR: "",
        username: "",
        Mode:"",
      },
      // accounts: globalPermissionStatus("Accounts"),
      componentKey: 0,
      revisedADDManifestationDetails: [],
      items: [],
      lastSelectItem: {},
      ledgerData: ["gfdg"],
      payList: [
        {
          payVal: "1",
          payText: "RTGS",
        },
        {
          payVal: "2",
          payText: "Cheque",
        },
      ],
      statusList: [
        {
          payVal: "1",
          payText: "PENDING",
        },
        {
          payVal: "2",
          payText: "COMPLETED",
        },
      ],
      ParticularList: [
        {
          partVal: "PAY TO LINE",
          partText: "PAY TO LINE",
        },
        {
          partVal: "PROFIT SHARE",
          partText: "PROFIT SHARE",
        },
        {
          partVal: "PAY TO CONSIGNEE",
          partText: "PAY TO CONSIGNEE",
        },
        {
          partVal: "SEA PRIORITY",
          partText: "SEA PRIORITY",
        },
        {
          partVal: "FREIGHT COLLECT FROM CONSIGNEE",
          partText: "FREIGHT COLLECT FROM CONSIGNEE",
        },
        {
          partVal: "ON CARRIAGE TO AGENT",
          partText: "ON CARRIAGE TO AGENT",
        },
        {
          partVal: "BILL TO CUSTOMER",
          partText: "BILL TO CUSTOMER",
        },
      ],
      currList: [
        {
          payVal: "INR",
          payText: "INR",
        },
        {
          payVal: "USD",
          payText: "USD",
        },
      ],
      TypeList: [
        {
          typeVal: "CREDIT",
          typeText: "CREDIT",
        },
        {
          typeVal: "DEBIT",
          typeText: "DEBIT",
        },
      ],
      showAlgo: false,
      docURL: URL_BASE_DOC,
      isLoading: false,
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      AddManifestationDetail: {
        itemCode: "addManifestationDetails",
        revisedMail: "0",
        manifestationId: "",
        allModuleId: this.$sessionsStorage.get("sendManifest_ffFclallModuleId"),
        ffExportFclId: this.$sessionsStorage.get("sendManifest_ffExportFclId"),
        ffFclConsoExportId: "",
        addManifestation_type: "",
        addManifestation_ledgerId: "",
        addManifestation_amount: "",
        addManifestation_currency: "1",
        addManifestation_remark: "",
        addManifestation_payStatus: "",
        userId: "",

        type_of_agent: "Agent",
        consignee_id: "",
        consignee_name: "",
        agent_coloder_txt: "",
        AgentColoader: "",

        paymentMode: "",
        payRefNumber: "",
        payDate: "",
        salesExeuctionNo: this.$sessionsStorage.get("sendManifest_JobSeries"),
        JobSeries: this.$sessionsStorage.get("sendManifest_JobSeries"),
        Jobtype: this.$sessionsStorage.get("sendManifest_Jobtype"),
        Transport_Type: this.$sessionsStorage.get("sendManifest_Transport_Type"),
        commonId: this.$sessionsStorage.get("sendManifest_ffExportFclId"),
        moduleType: this.$sessionsStorage.get("sendManifest_moduleType"),
        shipmentType: this.$sessionsStorage.get("sendManifest_shipmentType"),
        type:
          this.$sessionsStorage.get("sendManifest_Jobtype") +
          " " +
          this.$sessionsStorage.get("sendManifest_Transport_Type"),
        agent_coloder_txt: "",
        agent_coloder_id: "",
      },

      errorManifest: {
        AgentColoader: "",
        type_of_agent: "",
      },
      arrayErrorManifest: [
        {
          AgentColoader: "Please Select",
          type_of_agent: "Please Select Type",
        },
      ],

      permissionStatus: true,
      AddManifestationDetailArray: [],
      showMoreSB: false,

      role: this.$sessionsStorage.get("designation"),
      nextPageType: "",
      lineADDManifestationModalArray: [],
      last_updated: "",
      ManifestationCreated: "",
      ManifestationUpdated: "",
      validateINV: true,
      validate: true,
    };
  },

  mounted() { },

  destroyed() { },
  components: {
    DatePicker,
    ModelListSelect,
    MultiSelect,
    // Loading,
    CustomLoader,
    BannerComponent,
    Multiselect,
    ContainerTable,
  },
  computed: {
    disableSave() {
      return this.accounts == false &&
        this.role != "Admin" &&
        !this.AddManifestationDetail.manifestationId
        ? true
        : false;
    },
    AddManifestationDetailArrayList() {
      return this.AddManifestationDetailArray;
    },
    masterList() {
      return this.getLocationList;
    },
  },
  methods: {
    activateUser(item) {
      this.getSelectedContList=item;
      console.log("Container toggled:", item);
    },
    onSelectPaymentMode(event, item) {
      // console.log(event,item)
      // item.
      this.$forceUpdate();
    },
    onSelectPaymentStatus(event, item) {
      this.$forceUpdate();
    },
    onChoosePaymentDate(event, item) {
      this.$forceUpdate();
    },
    onChooseInvoiceDate(event, item) {
      this.$forceUpdate();
    },
    onSelectionChange(event) {
      console.log("Events= > ", event);
    },
    // deselect option
    reset() {
      this.items = []; // reset
    },
    // select option from parent component
    selectFromParentComponent() {
      this.items = _.unionWith(this.items, [this.options[0]], _.isEqual);
      console.log("Item =>", this.items);
    },
    addInvArry() {
      console.log("Add Manifestation Details");

      let obj = {
        manifestationId: "",
        allModuleId: this.$sessionsStorage.get("sendManifest_ffFclallModuleId"),
        ffExportFclId: this.$sessionsStorage.get("sendManifest_ffExportFclId"),
        moduleType: this.$sessionsStorage.get("sendManifest_moduleType"),
        shipmentType: this.$sessionsStorage.get("sendManifest_shipmentType"),
        JobSeries: this.$sessionsStorage.get("sendManifest_JobSeries"),
        isConsolidation: 0,
        ffFclConsoExportId: 0,
        type:
          this.$sessionsStorage.get("sendManifest_Jobtype") +
          " " +
          this.$sessionsStorage.get("sendManifest_Transport_Type"),
        Transport_Type: this.$sessionsStorage.get("sendManifest_Transport_Type"),
        Jobtype: this.$sessionsStorage.get("sendManifest_Jobtype"),
        ffFclConsoExportId: "",
        addManifestation_type: "",
        addManifestation_ledgerId: "",
        addManifestation_amount: "",
        addManifestation_currency: "1",
        addManifestation_remark: "",
        addManifestation_payStatus: "",
        container_count:1,
        final_amt:"",

        addManifestation_type_err: "",
        addManifestation_ledgerId_err: "",
        addManifestation_amount_err: "",
        addManifestation_currency_err: "",
        addManifestation_remark_err: "",
        addManifestation_payStatus_err: "",
      };
      this.lineADDManifestationModalArray.push(obj);

      console.log(this.lineADDManifestationModalArray.length);
    },

    RevisedAss(id) {
      // alert(id);
      var checkBox = document.getElementById(id).checked;
      console.log("Id => " + id + " : " + checkBox);
      if (checkBox) {
        (this.items = []), (this.lastSelectItem = {});
        for (let i = 0; i < lineADDManifestationModalArray.length; i++) {
          this.lineADDManifestationModalArray[i].addManifestation_type = "";
          this.lineADDManifestationModalArray[i].addManifestation_ledgerId = "";
          this.lineADDManifestationModalArray[i].addManifestation_amount = "";
          this.lineADDManifestationModalArray[i].addManifestation_currency = "";
          this.lineADDManifestationModalArray[i].addManifestation_remark = "";
          this.lineADDManifestationModalArray[i].addManifestation_payStatus = "";
          this.lineADDManifestationModalArray[i].container_count = 1;
          this.lineADDManifestationModalArray[i].final_amt = "";
        }
      }
    },

    addRevisedADDManifestation(index, id) {
      var checkBox = document.getElementById(id).checked;
      console.log("Id => " + id + " : " + checkBox);
      if (checkBox) {
        this.revisedADDManifestationDetails.push(
          this.lineADDManifestationModalArray[index]
        );
        this.lineADDManifestationModalArray[index].addManifestation_type = "";
        this.lineADDManifestationModalArray[index].addManifestation_ledgerId = "";
        this.lineADDManifestationModalArray[index].addManifestation_amount = "";
        this.lineADDManifestationModalArray[index].addManifestation_currency = "";
        this.lineADDManifestationModalArray[index].addManifestation_remark = "";
        this.lineADDManifestationModalArray[index].addManifestation_payStatus = "";
        this.lineADDManifestationModalArray[index].container_count = 1;
        this.lineADDManifestationModalArray[index].final_amt = "";
      } else {
        this.revisedADDManifestationDetails.splice(index, 1);
      }

      console.log("Revised mail => ", this.revisedADDManifestationDetails);
    },

    removeInvArry(index) {
      this.lineADDManifestationModalArray.splice(index, 1);
      this.TotalAMT();
    },

    getDueDate() {
      var date = new Date(this.AddManifestationDetail.sobDate);
      console.log(date);
      if (this.ImportDetail.shippingId == "15") {
        this.AddManifestationDetail.dueDate = date.setDate(date.getDate() + 9);
        this.AddManifestationDetail.dueDate = new Date(
          this.AddManifestationDetail.dueDate
        );
      } else if (this.ImportDetail.shippingId == "8") {
        this.AddManifestationDetail.dueDate = date.setDate(date.getDate() + 9);
        this.AddManifestationDetail.dueDate = new Date(
          this.AddManifestationDetail.dueDate
        );
      } else if (this.ImportDetail.shippingId == "13") {
        this.AddManifestationDetail.dueDate = date.setDate(date.getDate() + 9);
        this.AddManifestationDetail.dueDate = new Date(
          this.AddManifestationDetail.dueDate
        );
      } else if (this.ImportDetail.shippingId == "27") {
        this.AddManifestationDetail.dueDate = date.setDate(date.getDate() + 13);
        this.AddManifestationDetail.dueDate = new Date(
          this.AddManifestationDetail.dueDate
        );
      } else {
        this.AddManifestationDetail.dueDate = date.setDate(date.getDate() + 6);
        this.AddManifestationDetail.dueDate = new Date(
          this.AddManifestationDetail.dueDate
        );
      }
    },

    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    previousSalesView() {
      window.history.go(-1);
    },

    validateAddManifestationDetail() {
      let validate_new = true;
      let i = 0;
      let errCount = 0;
      let MainARR = this.lineADDManifestationModalArray;
      for (let j = 0; j < MainARR.length; j++) {
        if (this.accounts != false) {
          if (MainARR[j].addManifestation_ledgerId != "") {
            if (MainARR[j].addManifestation_payStatus == "") {
              this.lineADDManifestationModalArray[j]["addManifestation_payStatus_err"] =
                "Payment Status Field is Required";
              validate_new = false;
              ++errCount;
              break;
            } else {
              this.lineADDManifestationModalArray[j]["addManifestation_payStatus_err"] =
                "";
              validate_new = true;
            }
          }
        } else if (this.accounts == false || this.role == "Admin") {
          if (MainARR[j].addManifestation_type == "") {
            this.lineADDManifestationModalArray[j]["addManifestation_type_err"] =
              "Note Type Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineADDManifestationModalArray[j]["addManifestation_type_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].addManifestation_ledgerId == "") {
            this.lineADDManifestationModalArray[j]["addManifestation_ledgerId_err"] =
              "Particulars Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineADDManifestationModalArray[j]["addManifestation_ledgerId_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].addManifestation_amount == "") {
            this.lineADDManifestationModalArray[j]["addManifestation_amount_err"] =
              "Amount Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineADDManifestationModalArray[j]["addManifestation_amount_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].addManifestation_currency == "") {
            this.lineADDManifestationModalArray[j]["addManifestation_currency_err"] =
              "Currency Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineADDManifestationModalArray[j]["addManifestation_currency_err"] = "";
            validate_new = true;
          }
        }
      }
      console.log(
        "this.lineADDManifestationModalArray=>",
        this.lineADDManifestationModalArray
      );

      if (errCount > 0) {
        this.validateINV = false;
      }
      if (validate_new == false) {
        this.validateINV = false;
      } else {
        this.validateINV = true;
      }
    },
    getAgentConsigneeList(type_of_agent) {
      this.AddManifestationDetail.AgentColoader = "";
      if (type_of_agent == "Agent") {
        this.getAllAgentColoaderList = this.$store.getters[
          "common/getAllAgentColoaderList"
        ];
      } else if (type_of_agent == "Consignee") {
        this.getAllAgentColoaderList = this.$store.getters["common/getAllConsigneeList"];
      }
      this.AddManifestationDetail.AgentColoader = "";
      console.log("AgentColoader Details=>", this.AddManifestationDetail.AgentColoader);
    },
    getConsigneeAgentDetails() {
      this.AddManifestationDetail.consignee_id = "";
      this.AddManifestationDetail.consignee_name = "";
      this.AddManifestationDetail.agent_coloder_id = "";
      this.AddManifestationDetail.agent_coloder_txt = "";
      if (this.AddManifestationDetail.type_of_agent == "Consignee") {
        this.getAllAgentColoaderList.forEach((val, ind) => {
          if (val.agentName == this.AddManifestationDetail.AgentColoader) {
            console.log("Consignee Details=>", val);
            this.AddManifestationDetail.consignee_id = val.agntColoaderId;
            this.AddManifestationDetail.consignee_name = val.agentName;
          }
        });
      } else if (this.AddManifestationDetail.type_of_agent == "Agent") {
        this.getAllAgentColoaderList.forEach((val, ind) => {
          if (val.agentName == this.AddManifestationDetail.AgentColoader) {
            console.log("Agent Details=>", val);
            this.AddManifestationDetail.agent_coloder_id = val.agntColoaderId;
            this.AddManifestationDetail.agent_coloder_txt = val.agentName;
          }
        });
      }
    },
    validateManiFest() {
      let validate_new = true;
      Object.keys(this.errorManifest).map((x, index) => {
        if (
          this.AddManifestationDetail[x] == "" ||
          this.AddManifestationDetail[x] == undefined ||
          this.AddManifestationDetail[x] == null
        ) {
          this.errorManifest[x] = this.arrayErrorManifest[0][x];
          validate_new = false;
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    addAddManifestationDetail() {
      this.validateManiFest();
      this.validateAddManifestationDetail();
      if((this.getSelectedContList.length<=0 && this.ffExportDetail.Mode=='SEA') && this.$sessionsStorage.get("sendManifest_shipmentType").indexOf('TPT') >= 0||this.$sessionsStorage.get("sendManifest_shipmentType").indexOf('CC') >= 0||this.$sessionsStorage.get("sendManifest_shipmentType").indexOf('FF') >= 0){
           this.alert.content = "Please Select Atleast 1 Container";
          this.$refs["addPop"].open();
          return false;
        }
      if (this.validateINV == false || this.validate == false) {
        this.alert.content = "PLEASE ENTER ALL DETAILS.";
        this.$refs["addPop"].open();
        return false;
      }
      this.AddManifestationDetail.salesExeuctionNo = this.$sessionsStorage.get(
        "JOBSERIES"
      );
      this.AddManifestationDetail.allModuleId = this.$sessionsStorage.get(
        "sendManifest_ffFclallModuleId"
      );

      this.AddManifestationDetail.ffExportFclId = this.$sessionsStorage.get(
        "sendManifest_ffExportFclId"
      );

      this.AddManifestationDetail.ManifestationDetails = this.lineADDManifestationModalArray;

      if (this.revisedADDManifestationDetails.length > 0) {
        this.AddManifestationDetail.revisedADDManifestationDetails = this.revisedADDManifestationDetails;
      }

      this.AddManifestationDetail.TotAMT = this.TotAMT;
      let agentArr = this.$store.getters["common/getAllAgentColoaderList"].filter((x) => {
        return this.AddManifestationDetail.agent_coloder_txt === x.agentName;
      });
      if (this.AddManifestationDetail.type_of_agent == "Consignee") {
        let agentArr = this.$store.getters["common/getAllConsigneeList"].filter((x) => {
          return this.AddManifestationDetail.AgentColoader === x.agentName;
        });
        this.AddManifestationDetail.consignee_id = agentArr.length > 0 ? agentArr[0].agntColoaderId : '';
        this.AddManifestationDetail.consignee_name = agentArr.length > 0 ? agentArr[0].agentName : "";
      } else if (this.AddManifestationDetail.type_of_agent == "Agent") {
        let agentArr = this.$store.getters["common/getAllAgentColoaderList"].filter((x) => {
          return this.AddManifestationDetail.agent_coloder_txt === x.agentName;
        });
        this.AddManifestationDetail.agent_coloder_id = agentArr.length > 0 ? agentArr[0].agntColoaderId : "";
        this.AddManifestationDetail.agent_coloder_txt = agentArr.length > 0 ? agentArr[0].agentName : "";
      }

      this.AddManifestationDetail.container_count=this.getSelectedContList.length || 1;
      if (this.getSelectedContList && this.getSelectedContList.length > 0) {
        this.AddManifestationDetail.container_selected = this.getSelectedContList
          .map(c => c.containerNo)
          .join(',');
      } else {
        this.AddManifestationDetail.container_selected = '';
      }
      this.AddManifestationDetail.TotAMT1 = this.AddManifestationDetail.container_count*this.TotAMT;
      // this.AddManifestationDetail.agent_coloder_id = agentArr[0].agntColoaderId;
      console.log("agentArr=>", agentArr);
      // console.log("After => ", this.AddManifestationDetail);
      // return false;
      let payload = {
        itemCode: "addManifestationDetails",
        AddManifestationDetail: this.AddManifestationDetail,
      };
      // alert(this.validateINV);
      // alert(this.validate);

      if (this.validateINV != false) {
        $("#addButtonLoaderSB").css("display", "none");
        $("#loaderSB").css("display", "block");

        CommonService.getAllManifestationDetails(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              $("#loaderSB").css("display", "none");
              $("#addButtonLoaderSB").css("display", "block");
              if (data.manifestationId != "" && data.manifestationId != undefined) {
                if (data.find == 1 || data.find == 2) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.$refs["addPop"].open();
              this.getData();
              window.history.go(-1);
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on Add Manifetstion Error: ", error);
          });
      }
    },

    getData() {
      this.doLoading();
      let payload = {
        itemCode: "geManifestationDetails",
        allModuleId: this.$sessionsStorage.get("sendManifest_ffFclallModuleId"),
        ffExportFclId: this.$sessionsStorage.get("sendManifest_ffExportFclId"),
        moduleType: this.$sessionsStorage.get("sendManifest_moduleType"),
        shipmentType: this.$sessionsStorage.get("sendManifest_shipmentType"),
        JobSeries: this.$sessionsStorage.get("sendManifest_JobSeries"),
        isConsolidation: 0,
        ffFclConsoExportId: 0,
        type:
          this.$sessionsStorage.get("sendManifest_Jobtype") +
          " " +
          this.$sessionsStorage.get("sendManifest_Transport_Type"),
        Transport_Type: this.$sessionsStorage.get("sendManifest_Transport_Type"),
        Jobtype: this.$sessionsStorage.get("sendManifest_Jobtype"),
      };
      CommonService.getAllManifestationDetails(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            console.log("MyDataArr=>", data);
            console.log("Priyanshu Singh=>", data.mainManifestationData);

            if (data.editFFEX.length > 0) {
              Object.keys(data.editFFEX[0]).map((x) => {
                this.ffExportDetail[x] = data.editFFEX[0][x] || "";
              });
              this.mainSalesSeries = data.editFFEX[0].mainSalesSeries;
              let mydata = [];
              this.branch_code = "";
              mydata = this.mainSalesSeries.split("/");
              this.branch_code = mydata[2];
            }
            if (data.mainManifestationData.length > 0) {
              Object.keys(this.lineADDManifestationModalArray).map((x) => {
                this.lineADDManifestationModalArray[x] =
                  data.mainManifestationData[0][x] || "";
              });
              this.getSelectedContList=data.mainManifestationData[data.mainManifestationData.length-1].container_selected.split(",");
              
              this.AddManifestationDetailArray = data.mainManifestationData;
              this.ManifestationCreated = data.ManifestationCreated;
              this.ManifestationUpdated = data.ManifestationUpdated;
              let i = 0;
              data.mainManifestationData.forEach((element) => {
                this.AddManifestationDetail.agent_coloder_txt = element.agent_coloder_txt;
                this.last_updated = element.last_updated || "";
                this.AddManifestationDetail.manifestationId =
                  element.manifestationId || "";
                element["manifestationId"] = element.manifestationId || "";
                element["allModuleId"] = element.allModuleId || "";
                element["addManifestation_type"] = element.noteType || "";
                element["addManifestation_ledgerId"] = element.ledgerId || "";
                element["addManifestation_amount"] = element.amount || "";
                element["addManifestation_currency"] = element.currency || "";
                element["addManifestation_remark"] = element.remark || "";
                element["container_count"] = element.container_count || 1;
                element["final_amt"] = element.container_count*element.amount;
                this.lineADDManifestationModalArray.push(element);

                this.AddManifestationDetail = {
                  type_of_agent: element.type_of_agent || "",
                  consignee_id: element.consignee_id || "",
                  consignee_name: element.consignee_name || "",
                  agent_coloder_txt: element.agent_coloder_txt || "",
                  AgentColoader:
                    element.type_of_agent == "Agent"
                      ? element.agent_coloder_txt
                      : element.consignee_name || "",
                };
                i++;
              });
              if (this.lineADDManifestationModalArray.length > 0) {
                this.TotalAMT();
                console.log("Menifest Details=>", this.lineADDManifestationModalArray);
              }

              this.AddManifestationDetail.revisedMail = 0;
            }
          }
          this.doLoadingClose();
        })
        .catch((error) => {
          console.log("Catch on getAllManifestationDetails Error: ", error);
        });
    },
    CheckValueNumbers(item, arr) {
      if (!isNaN(item)) {
        if (Number.isInteger(item)) {
        }
      } else {
        this.alert.content = "Please Enter Only Integer and Decimal Values";
        this.$refs["addPop"].open();
      }
    },
    updateAmount(item){
      item.final_amt=item.container_count*item.addManifestation_amount;
    },
    TotalAMT() {
      this.TotAMT = 0;
      this.TotDebit = 0;
      this.TotCredit = 0;
      let TotAmount = 0;
      let TotCredit_Val = 0;
      let TotDebit_Val = 0;
      let amount = 0;
      let Credit_Val = 0;
      let Debit_Val = 0;
      this.lineADDManifestationModalArray.forEach((value, index) => {
        let SIGN = "";
        Credit_Val = 0;
        Debit_Val = 0;
        //  alert(value.addManifestation_amount)
        if (isNaN(value.addManifestation_amount) || value.addManifestation_amount == "") {
          amount = 0;
          Credit_Val = 0;
          Debit_Val = 0;
          value.final_amt=0;
        } else {
          value.final_amt=value.addManifestation_amount*value.container_count;
          amount = value.final_amt;

          if (value.addManifestation_type == "CREDIT") {
            Credit_Val = amount;
            SIGN = "-";
          }
          // alert(value.addManifestation_type)
          if (value.addManifestation_type == "DEBIT") {
            Debit_Val = amount;
            SIGN = "+";
          }
        }
        // alert(Debit_Val)
        if (this.TotAMT == 0) {
          TotCredit_Val = eval(Credit_Val);
          TotDebit_Val = eval(Debit_Val);
          TotAmount = eval(Debit_Val) - eval(Credit_Val);
        } else {
          TotDebit_Val = eval(TotDebit_Val) + eval(Debit_Val);
          TotCredit_Val = eval(TotCredit_Val) + eval(Credit_Val);
          // TotAmount = eval(TotDebit_Val)-eval(TotCredit_Val)+eval(TotAmount);
          // TotAmount = eval(TotAmount+SIGN+amount);
          // TotAmount = eval(TotAmount)+eval(amount);
        }
        this.TotAMT = TotAmount;
        this.TotDebit = TotDebit_Val;
        this.TotCredit = TotCredit_Val;
        // alert(this.TotDebit);
        // alert(this.TotCredit);
      });
      this.TotAMT = eval(TotDebit_Val - TotCredit_Val);
      console.log("this.totFinalAmount item=>", this.TotAMT);
      this.$forceUpdate();
    },
    TotalAMT_bak(item) {
      if (!isNaN(item)) {
        // alert(this.TotAMT);
        // alert(item);
        if (item == "") {
          item = 0;
          if (item != "") {
            this.lineADDManifestationModalArray.forEach((element) => {
              if (this.TotAMT == 0) {
                this.TotAMT = parseInt(element.amount);
              } else {
                this.TotAMT = parseInt(this.TotAMT) + parseInt(element.amount);
              }
            });
          }
        }
        if (this.TotAMT == 0) {
          this.TotAMT = parseInt(item);
        } else {
          this.TotAMT = parseInt(this.TotAMT) + parseInt(item);
        }
      } else {
        this.TotAMT = 0;
      }
      // if(item != ""){
      //   this.lineADDManifestationModalArray.forEach((element) => {

      //   });
      // }
    },
    // JqueryFun() {
    //   return $(function() {
    //     return $("#ccContainer").DataTable();
    //   });
    // }
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}

.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// ffCommonManifestation.vue?13f97e39